export default __webpack_public_path__ + "static/media/Bandeau 26bis HD.2417009f.jpg";